/* eslint-disable no-debugger */
import React, { useState } from 'react';
import useForm from 'react-hook-form';
import axios from 'axios';
import Alert from '../alert/alert';
import Navbar from '../layout/Navbar';
import Footer from '../footer/Footer';
import SideDrawer from '../SideDrawer/SideDrawer';
import ApiContext from '../Context/ApiContext';

import { NavLink } from 'react-router-dom';

const SignUp = (props) => {
  const { register, handleSubmit, errors } = useForm();
  const { showSuccess, showFailed } = new Alert();

  const [sideDrawerStatus , setSideDrawer] = useState(false);
    

  const fileHandle = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
  };

  const convertUserObjectToFormData = (user) => {
    const data = Object.entries(user);
    const formData = new FormData();
    data.forEach((item, index, array) => {
      if (item[0] === 'image') {
        formData.append(item[0], item[1][0]);
      } else {
        formData.append(item[0], item[1]);
      }
    });

    return formData;
  };

  const onSubmit = async (data) => {
    const formData = convertUserObjectToFormData(data);

    const url = 'https://justcodedsoftskillssolutions.herokuapp.com/api/teachers';
    await axios
      .post(url, formData)
      .then((res) => {
        if (res.data) {
          showSuccess('Registration successful');
          props.history.push('/signin');
        } else {
          showFailed('Failed to register user, please try again');
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  return (
    <ApiContext.Provider value={{
      sideDrawerStatus : sideDrawerStatus,
      setSideDrawer : (()=>setSideDrawer(!sideDrawerStatus))
    }}>

    <div>
      <main className="main main-bg">
        <SideDrawer />
        <Navbar home="Home" signin="Sign In" />
        <div className="wrap">
          <h1
            className="text-center"
            style={{
              padding: '4rem'
            }}
          >
            Register for a Course
          </h1>
          <form className="container-md text-white" encType="multiparty/form-data" onSubmit={handleSubmit(onSubmit)}>
            <div className="row row-switch">
              <div className="col">
                {errors.firstName && (
                  <p className="text-danger">This field is required and most be a minimun of 3 letters</p>
                )}
                <div className="input-group form-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text text-danger" id="addon-wrapping">
                      <i className="fas fa-user"></i>
                    </span>
                  </div>

                  <input
                    className="form-control"
                    type="text"
                    name="firstName"
                    ref={register({ required: true, minLength: 3 })}
                    placeholder="First Name"
                  />
                </div>
                {errors.lastName && (
                  <p className="text-danger">This field is required and must be a minimum of 3 letters</p>
                )}
                <div className="input-group form-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text text-danger" id="addon-wrapping">
                      <i className="fas fa-user"></i>
                    </span>
                  </div>

                  <input
                    className="form-control"
                    type="text"
                    name="lastName"
                    ref={register({ required: true, minLength: 3 })}
                    placeholder="Last Name"
                  />
                </div>
                <div className="input-group form-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      <i className="fas fa-at"></i>
                    </span>
                  </div>
                  <input
                    className="form-control"
                    type="text"
                    name="username"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    ref={register}
                    placeholder="Username"
                  />
                </div>
                {errors.email && <p className="text-danger">This field is required</p>}
                <div className="input-group form-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text text-danger" id="addon-wrapping">
                      <i className="fas fa-envelope"></i>
                    </span>
                  </div>
                  <input
                    className="form-control"
                    type="email"
                    name="email"
                    ref={register({ required: true })}
                    placeholder="Email"
                  />
                </div>

                {errors.phone && <p className="text-danger">This field is required</p>}
                <div className="input-group form-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text text-danger" id="addon-wrapping">
                      <i className="fas fa-phone-alt"></i>
                    </span>
                  </div>

                  <input
                    className="form-control"
                    name="phone"
                    type="tel"
                    ref={register({ required: true })}
                    placeholder="Telephone"
                  />
                </div>
                {errors.password && (
                  <p className="text-danger">This field is required and most be a minimun of 6 letters</p>
                )}
                <div className="input-group form-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text text-danger" id="addon-wrapping">
                      <i className="fas fa-lock"></i>
                    </span>
                  </div>
                  <input
                    className="form-control"
                    type="password"
                    name="password"
                    ref={register({ required: true, minLength: 6 })}
                    placeholder="Password"
                  />
                </div>
                  <div className="input-group form-group">
                  <label className="">Select course of study:</label>
                  <span style={{ paddingRight: '1rem' }}></span>
                  <select name="gpa" ref={register({ required: true })}>
                    <option value="frontend">Frontend Programming</option>
                    <option value="backend">Backend Programming</option>
                    <option value="fullstack">Full Stack</option>
                    <option value="datascience">Data Analytics & Science</option>
                    <option value="databasemanagement">DBMS</option>
                  </select>
                </div>

              
                <div className="form-group">
                  <label>Upload your passport photo</label>
                  <span style={{ paddingRight: '0.5rem' }}></span>
                  <input type="file" name="image" ref={register} onChange={fileHandle} />
                </div>

                <div className="input-group form-group">
                  <span className="text-danger">*</span>
                  <label className="">
                    <input type="radio" name="gender" value="male" ref={register} /> Male
                  </label>
                  <label className="">
                    <input type="radio" name="gender" value="female" ref={register} defaultChecked /> Female
                  </label>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <button className="btnSubmit" type="submit">
                REGISTER
              </button>
            </div>
          </form>
          <div className="switch_link">
            <span className="p-2">Already have an account?</span>
            <NavLink className="nav_link" activeClassName="current" to="/signin">
              Log In
            </NavLink>
          </div>
        </div>
      </main>
      <Footer />
    </div>
    </ApiContext.Provider>
  );
};

export default SignUp;
